import { colors, useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    sectionDragHandle: {
      marginRight: theme.spacing(2),
      color: colors.grey[600],
    },
  };
};
